import React                                                from 'react';
import { TogglableContentHook, useTogglableContentReducer } from './useTogglableContentReducer'
import { SidebarProps }                                     from 'semantic-ui-react';

export const useSidebar = (): TogglableContentHook<SidebarProps> => {
	
	return useTogglableContentReducer<SidebarProps>();
};
